<template>
  <IQOS required v-if="shouldShow">
      <template #title>
          <span class="orange-4-color warning-title">
              <BaseIcon icon="allert" class="mr-8"/>
              {{ $t('integrations.poster_health.title') }}</span>
      </template>

      <div class="warning mt-16" v-if="health.missing_waiters.length">
          <span class="v1-grey-7-color qrw-label-sm bold mb-16">{{ $t('integrations.poster_health.waiters_title')}}</span>
          <p class="v1-grey-10-color qrw-paragraph-md mt-16" v-for="waiter in health.missing_waiters" :key="waiter">
              - {{ waiter }}
          </p>
          <!-- <p class="comment c-grey pt-0">
              {{ $t('integrations.poster_health.waiters_desc')}}
          </p> -->
          
      </div>
      <div class="warning mt-16" v-if="health.missing_halls.length">
          <span class="v1-grey-7-color qrw-label-sm bold mb-16">{{$t('integrations.poster_health.halls_title')}}</span>

          <p class="v1-grey-10-color qrw-paragraph-md mb-16" v-for="hall in health.missing_halls" :key="hall">
              - {{ hall }}
          </p>
          <!-- <p class="comment c-grey pt-0">
              {{ $t('integrations.poster_health.halls_desc') }}
          </p> -->
      </div>

      <p class="qrw-label-sm orange-4-color mt-16">
          {{ $t('integrations.poster_health.not_healthy') }}
      </p>
  </IQOS>
</template>

<script>
import IQOS from '@/components/IQOS.vue'

import PosterAPI from '@/api/poster'

export default {
    data() {
        return {
            health: {
                missing_waiters: [],
                missing_halls: []
            }
        }
    },
    methods: {
        fetchHealth() {
            PosterAPI.getHealth(this.$store.state.cafe._id).then(data => {
                this.health = data.health;
            }).catch(err => {

            });
        }
    },
    mounted() {
        this.fetchHealth();
    },
    components: {
        IQOS
    },
    computed: {
        shouldShow() {
            return this.health.missing_waiters.length || this.health.missing_halls.length;
        }
    }
}
</script>

<style>
.warning-title {
  display: flex;
  align-content: center;
  align-items: center;
}
</style>